module.exports = __webpack_public_path__ + "static/media/soundTrack_1.b64aa04b.mp3";